import { apiPath } from "@/api/api-path"
import { DateTime } from "luxon"
import api from "./service"

//
// Credentials
//
export async function addCredentials(type, request) {
  const path = type === "snmp" ? apiPath.addSnmp : apiPath.addRemote

  return api
    .post(path, request, {})
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCredentialsList(type, filter) {
  const path = type === "snmp" ? apiPath.getSnmpList : apiPath.getRemoteList

  return api
    .get(path, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getCredentialsById(type, id) {
  const path = type === "snmp" ? apiPath.getSnmpById : apiPath.getRemoteById

  return api
    .get(path + id)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateCredentialsById(type, id, request) {
  const path =
    type === "snmp" ? apiPath.updateSnmpById : apiPath.updateRemoteById

  return api
    .put(path + id, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteCredentialsById(type, id) {
  const path =
    type === "snmp" ? apiPath.deleteSnmpById : apiPath.deleteRemoteById

  return api
    .delete(path + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

//
// AUTO BACKUP CONFIG
//

// Get Auto Backup Config List
export async function getAutoBackupConfigList(filter) {
  return api
    .get(apiPath.getAutoBackupConfigList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Auto Backup Config By ID
export async function getAutoBackupConfigDetailById(autoBackupConfigId) {
  const path = apiPath.getAutoBackupConfigDetailById.replace(
    "{id}",
    autoBackupConfigId
  )
  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Delete Auto Backup Config List
export async function deleteAutoBackupConfig(autoBackupConfigId) {
  const path = apiPath.deleteAutoBackupConfig.replace(
    "{id}",
    autoBackupConfigId
  )
  return api
    .delete(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

// Create Auto Backup Config List
export async function createNewAutoBackupConfig(autoBackupConfigData) {
  return api
    .post(apiPath.createAutoBackupConfig, autoBackupConfigData, {})
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Edit Auto Backup Config List
export async function editAutoBackupConfig(
  autoBackupConfigId,
  autoBackupConfigData
) {
  const path = apiPath.editAutoBackupConfig.replace("{id}", autoBackupConfigId)
  return api
    .put(path, autoBackupConfigData, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// TAGS
//
export async function getTagsList() {
  return api
    .get(apiPath.getTagsList, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// NODES
//

// Discovery by subnet
export async function discoveryBySubnet(subnet) {
  return api
    .post(apiPath.discoveryBySubnet, { subnet }, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Add Nodes
export async function addNodes(request) {
  return api
    .post(apiPath.addNodes, request, {})
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Node List
export async function getNodeList(filter) {
  return api
    .get(apiPath.getNodeList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Node Detail By Id
export async function getNodeDetailById(nodeId) {
  const path = apiPath.getNodeDetailById.replace("{id}", nodeId)
  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Update Node Tags (Single)
export async function updateNodeTag(selectedNodeId, tagList) {
  const path = apiPath.updateNodeTag.replace("{id}", selectedNodeId)
  return api
    .put(path, tagList, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Update Nodes Tags (Multiple)
export async function updateNodesTags(updateNodesTagsData) {
  return api
    .patch(apiPath.updateNodesTags, updateNodesTagsData, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Update Nodes SNMP Credential
export async function updateNodesSnmp(updateNodesSnmpData) {
  return api
    .patch(apiPath.updateNodesSnmp, updateNodesSnmpData, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Update Nodes Remote Credential
export async function updateNodesRemote(updateNodesRemoteData) {
  return api
    .patch(apiPath.updateNodesRemote, updateNodesRemoteData, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Delete Nodes
export async function deleteNodes(nodeIds) {
  return api
    .delete(apiPath.deleteNodes, {
      data: {
        ...nodeIds,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Config Change Trend Graph
export async function getConfigChangeTrendGraph(nodeId, duration) {
  const path = apiPath.getConfigChangeTrendGraph.replace("{id}", nodeId)

  return api
    .get(path, {
      params: {
        Duration: duration,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// Templates
//

// Get template list
export async function getTemplateList(filter) {
  return api
    .get(apiPath.getTemplateList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get template by id
export async function getTemplateById(id) {
  return api
    .get(apiPath.getTemplateById + id, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Create Template
export async function createTemplate(request) {
  return api
    .post(apiPath.createTemplate, request, {})
    .then((response) => {
      if (response.status === 201) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Update Template
export async function updateTemplate(id, request) {
  return api
    .put(apiPath.updateTemplate + id, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Delete Template
export async function deleteTemplate(id) {
  return api
    .delete(apiPath.deleteTemplate + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Generate Template
export async function generateTemplate(id, request) {
  return api
    .post(apiPath.generateTemplate + id + "/generate", request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

//
// CONFIGURATION CHANGE
//

// Get Configuration Change List
export async function getConfigurationChangeList(filter) {
  return api
    .get(apiPath.getConfigurationChangeList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Configuration Change Version
export async function getConfigurationChangeVersion(nodeId) {
  const path = apiPath.getConfigurationChangeVersion.replace("{nodeId}", nodeId)
  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Configuration Change Version with Datetime
export async function getConfigVersionWithTimestamp(nodeId) {
  const path = apiPath.getConfigVersionWithTimestamp.replace("{nodeId}", nodeId)

  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Get Configuration Detail
export async function getNodeConfigurationDetail(nodeId, changeVersion) {
  const path = apiPath.getNodeConfigurationDetail
    .replace("{nodeId}", nodeId)
    .replace("{changeVersion}", changeVersion)

  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// Export all latest configuration

export async function exportLatestConfiguration() {
  return api
    .get(apiPath.exportLatestConfiguration, {
      responseType: "blob",
    })
    .then((response) => {
      if (response.status === 200) {
        const href = URL.createObjectURL(response.data)
        const link = document.createElement("a")
        link.href = href
        link.setAttribute(
          "download",
          `Latest_Config_${DateTime.now().toFormat("yyyy-MM-dd")}`
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        return response.data
      }
    })
    .catch((error) => {
      console.error(error)
    })
}
